import { render } from "./FrontOfficerDashboard.vue?vue&type=template&id=5b457214"
import script from "./FrontOfficerDashboard.vue?vue&type=script&lang=js"
export * from "./FrontOfficerDashboard.vue?vue&type=script&lang=js"
script.render = render

export default script